import React, { useState } from 'react';
import { Card, CardContent } from './card';

const StatCard = ({ icon: Icon, title, value, iconColor = "text-blue-500", tooltipContent }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Card className="p-6 relative">
      <CardContent 
        className="flex items-center space-x-4 p-0"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <div className={`p-3 rounded-lg bg-gray-100 ${iconColor}`}>
          <Icon size={24} />
        </div>
        <div>
          <p className="text-sm text-gray-600 font-medium">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
        </div>
        {tooltipContent && showTooltip && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg whitespace-pre-line z-50 min-w-max">
            {tooltipContent}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
              <div className="border-8 border-transparent border-t-gray-900" />
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard; 